import Account from "../assets/icons/account.svg?react";
import Add from "../assets/icons/add.svg?react";
import Analytics from "../assets/icons/analytics.svg?react";
import ArrowRight from "../assets/icons/arrow-right.svg?react";
import Article from "../assets/icons/article.svg?react";
import Assignment from "../assets/icons/assignment.svg?react";
import Attachment from "../assets/icons/attachment.svg?react";
import Block from "../assets/icons/block.svg?react";
import Calendar from "../assets/icons/calendar.svg?react";
import CheckCircle from "../assets/icons/check-circle.svg?react";
import CheckList from "../assets/icons/check-list.svg?react";
import ChevronLeft from "../assets/icons/chevron-left.svg?react";
import Close from "../assets/icons/close.svg?react";
import Copy from "../assets/icons/copy.svg?react";
import Create from "../assets/icons/create.svg?react";
import Done from "../assets/icons/done.svg?react";
import DragHandle from "../assets/icons/drag-handle.svg?react";
import Edit from "../assets/icons/edit.svg?react";
import Expand from "../assets/icons/expand.svg?react";
import FeedbackCheckmark from "../assets/icons/feedback-checkmark.svg?react";
import FeedbackUnread from "../assets/icons/feedback-unread.svg?react";
import Feedback from "../assets/icons/feedback.svg?react";
import Fill from "../assets/icons/fill.svg?react";
import Filter from "../assets/icons/filter.svg?react";
import Heart from "../assets/icons/heart.svg?react";
import Icbt from "../assets/icons/icbt.svg?react";
import Info from "../assets/icons/info.svg?react";
import Logo from "../assets/icons/logo.svg?react";
import Logout from "../assets/icons/logout.svg?react";
import MCLogo from "../assets/icons/mc-logo.svg?react";
import MindlerLogo from "../assets/icons/mindler-logo.svg?react";
import Message from "../assets/icons/message.svg?react";
import MoreVert from "../assets/icons/more-vert.svg?react";
import NoFeedback from "../assets/icons/no-feedback.svg?react";
import Notifications from "../assets/icons/notifications.svg?react";
import NoteAdd from "../assets/icons/note-add.svg?react";
import Notes from "../assets/icons/notes.svg?react";
import Pause from "../assets/icons/pause.svg?react";
import Payment from "../assets/icons/payment.svg?react";
import Phone from "../assets/icons/phone.svg?react";
import Play from "../assets/icons/play.svg?react";
import Plus from "../assets/icons/plus.svg?react";
import Profile from "../assets/icons/profile.svg?react";
import Read from "../assets/icons/read.svg?react";
import Questionnaires from "../assets/icons/questionnaires.svg?react";
import Search from "../assets/icons/search.svg?react";
import Send from "../assets/icons/send.svg?react";
import Clock from "../assets/icons/clock.svg?react";
import Settings from "../assets/icons/settings.svg?react";
import Shortcut from "../assets/icons/shortcut.svg?react";
import SortAsc from "../assets/icons/sort-asc.svg?react";
import Slot from "../assets/icons/slot.svg?react";
import SortDesc from "../assets/icons/sort-desc.svg?react";
import Template from "../assets/icons/template.svg?react";
import Toggle from "../assets/icons/toggle.svg?react";
import Trash from "../assets/icons/trash.svg?react";
import TreatmentInfo from "../assets/icons/treatmentInfo.svg?react";
import TrendingDown from "../assets/icons/trending-down.svg?react";
import TrendingUp from "../assets/icons/trending-up.svg?react";
import Verified from "../assets/icons/verified.svg?react";
import Video from "../assets/icons/video.svg?react";
import Warning from "../assets/icons/warning.svg?react";
import AutomaticSent from "../assets/icons/automatic-sent.svg?react";
import ExternalLink from "../assets/icons/external-link.svg?react";
import ThumbsUp from "../assets/icons/thumbs-up.svg?react";
import ThumbsDown from "../assets/icons/thumbs-down.svg?react";
import Lock from "../assets/icons/lock.svg?react";
import VisibilityOn from "../assets/icons/visibility-on.svg?react";
import VisibilityOff from "../assets/icons/visibility-off.svg?react";

export const Icon = {
  Account,
  Add,
  AutomaticSent,
  Analytics,
  ArrowRight,
  Article,
  Assignment,
  Attachment,
  Block,
  Calendar,
  CheckCircle,
  CheckList,
  ChevronLeft,
  Close,
  Copy,
  Clock,
  Create,
  Done,
  DragHandle,
  Edit,
  Expand,
  ExternalLink,
  Feedback,
  FeedbackUnread,
  FeedbackCheckmark,
  Filter,
  Heart,
  Icbt,
  Info,
  Logo,
  Logout,
  MCLogo,
  MindlerLogo,
  Message,
  MoreVert,
  NoFeedback,
  NoteAdd,
  Notes,
  Notifications,
  OpenInFull: Fill,
  Pause,
  Payment,
  Phone,
  Play,
  Plus,
  Profile,
  Read,
  Questionnaires,
  Search,
  Send,
  Settings,
  Shortcut,
  SortAsc,
  SortDesc,
  Slot,
  Template,
  Toggle,
  Trash,
  TrendingDown,
  TrendingUp,
  TreatmentInfo,
  Verified,
  Video,
  Warning,
  ThumbsUp,
  ThumbsDown,
  Lock,
  VisibilityOn,
  VisibilityOff,
} as const;

export type Icon = keyof typeof Icon;
